import * as actionTypes from "../actionTypes";

export const initialState: { profile: actionTypes.profile | undefined } = {
    profile: undefined
};

const reducer = (
    state = initialState,
    action: {
        type: string;
        payload: actionTypes.profile
    }
): typeof initialState => {
    switch (action.type) {
        case actionTypes.SET_PROFILE: {
            return {
                ...state,
                profile: action.payload
            }
        }
        case actionTypes.CLEAR_PROFILE: {
            return {
                ...state,
                profile: undefined
            }
        }
        default: {
            return state;
          }
    }
}

export default reducer;
